import { VariablesOf } from '@graphql-typed-document-node/core';
import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import { EVENTS_PER_PAGE_COLLECTION } from 'constants/events.constant';
import { datoRequester } from 'queries/requesters';
import { StaleTime } from 'queries/types';
import {
  PageCollectionDocument,
  PageEventsDocument,
} from 'types/api/dato-operations.types';

const COLLECTIONS_PREFIX = 'collections';

export const pageCollectionQuery = (
  variables: VariablesOf<typeof PageCollectionDocument>,
) =>
  queryOptions({
    queryKey: [COLLECTIONS_PREFIX, 'detail', variables],
    queryFn: datoRequester(PageCollectionDocument, variables),
  });

export const collectionEventsQuery = (
  variables: VariablesOf<typeof PageEventsDocument>,
  eventsPerPage: number = EVENTS_PER_PAGE_COLLECTION,
) => {
  //Removed endDatetime because date server/Azie was not same as on client -> Server/Client hydration mismatch due to different querykeys
  const { endDatetime, ...restFilters } = variables.filter || {};
  const restVariables = { ...variables, filter: restFilters };
  return infiniteQueryOptions({
    queryKey: [COLLECTIONS_PREFIX, 'events', restVariables],
    queryFn: async (ctx) => {
      const { allPageEvents, meta } = await datoRequester(PageEventsDocument, {
        ...variables,
        skip: ctx.pageParam,
      })(ctx);

      const events = allPageEvents ?? [];

      return { events, meta };
    },

    staleTime: StaleTime.FIVE_MIN,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const totalLoadedCount = allPages.reduce(
        (acc, item) => acc + item.events.length,
        0,
      );

      const totalCount = lastPage.meta.count;

      return totalLoadedCount < totalCount
        ? allPages.length * eventsPerPage
        : undefined;
    },
  });
};
